import type { IMembersAreaWidgetPluginService } from '@wix/members-area-widget-plugin-lib/viewer';

import type { SettingsEventHandler } from '../components/Profile/controller-listeners';
import type { getActionHandlers } from '../store';
import type { RootState } from '../store/root-reducer';
import type { FlowApi, SetProps, WixCodeApi } from './editor-flow';
import type {
  MembersAboutMiddlewareService,
  WarmupDataService,
} from './services';

type ActionHandlers = ReturnType<typeof getActionHandlers>;
type MemberHandlers = ActionHandlers['memberHandlers'];
type BlogPostsHandlers = ActionHandlers['blogPostsHandlers'];
type SiteHandlers = ActionHandlers['siteHandlers'];
type UIHandlers = ActionHandlers['uiHandlers'];

export type ControllerContext = {
  flowAPI: FlowApi;
  wixCodeApi: WixCodeApi;
  setProps: SetProps;
  widgetPluginService: IMembersAreaWidgetPluginService;
  warmupDataService: WarmupDataService;
  settingsListener: SettingsEventHandler;
  membersAboutMiddlewareService: MembersAboutMiddlewareService;
};

export enum BuilderState {
  NoMemberProfile = 'noMemberProfile',
  EditingAboutDescription = 'editingAboutDescription',
  WithAboutDescription = 'withAboutDescription',
  NoBlogPosts = 'noBlogPosts',
}

export interface ControllerProps {
  instance: string;
  member: RootState['member'];
  defaultBIParams: Object;
  site: RootState['site'];
  badges: RootState['badges'];
  blogPosts: RootState['blogPosts'];
  ui: RootState['ui'];
  appSettings: RootState['appSettings'];
  memberHandlers: MemberHandlers;
  blogPostsHandlers: BlogPostsHandlers;
  siteHandlers: SiteHandlers;
  uiHandlers: UIHandlers;
  isRendered: boolean;
  fitToContentHeight?: true;
  builderState?: BuilderState;
}

export enum WarmupDataKey {
  InitialData = 'initialData',
}
